export default __webpack_public_path__ + "static/media/alliances-1.5654a0de.jpg";